import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { DatastoreClearEffect } from './store-clear.effect';

@NgModule({
  imports: [EffectsModule.forFeature([DatastoreClearEffect])],
})
export class StoreClearModule {}
